export default __webpack_public_path__ + "images/about/3 Юлия Шиман дизайнер.jpg";